import styled, { css } from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from '../../fields.constants';

export const Rail = styled.nav`
  display: flex;
  flex-direction: column;
  gap: ${em(6)};
  min-width: 0;
`;

export const RailTitle = styled.h2`
  ${({ theme }) => css`
    margin: 0;
    font-size: ${rem(14)};
    font-weight: ${theme.fontWeights[1]};
    color: ${theme.colors.nature.n5};
  `}
`;

export const SortRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${em(6)};
    font-size: ${rem(12)};
    color: ${theme.colors.nature.n3};
  `}
`;

export const SortSelect = styled.select`
  ${({ theme }) => css`
    flex: 1;
    padding: ${em(3)} ${em(6)};
    font-size: ${rem(12)};
    color: ${theme.colors.nature.n5};
    background: ${theme.colors.nature.n0};
    border: ${em(1)} solid ${theme.colors.nature.n2};
    border-radius: ${em(theme.radius[0])};
  `}
`;

export const Item = styled.button`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${em(5)};
    padding: ${em(10)} ${em(12)};
    background: ${theme.colors.nature.n0};
    border: none;
    border-left: ${em(2)} solid transparent;
    border-radius: ${em(theme.radius[0])};
    box-shadow: ${theme.shadows()[0]};
    text-align: left;
    cursor: pointer;

    &:hover {
      background: ${theme.colors.misc.background};
    }

    &[aria-pressed='true'] {
      background: ${theme.colors.misc.background2};
      border-left-color: ${theme.colors.nature.n5};
    }
  `}
`;

export const FieldName = styled.span`
  ${({ theme }) => css`
    font-size: ${rem(14)};
    font-weight: ${theme.fontWeights[1]};
    color: ${theme.colors.nature.n5};
  `}
`;

export const Bar = styled.div`
  height: 4px;
  background: ${PALETTE.line};
  border-radius: 3px;
  overflow: hidden;
`;

export const BarFill = styled.div`
  height: 100%;
  background: ${PALETTE.brand};
`;

export const Foot = styled.span`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    gap: ${em(8)};
    font-size: ${rem(12)};
    color: ${theme.colors.nature.n3};
  `}
`;

const emphasis = css`
  ${({ theme }) => css`
    b {
      font-weight: ${theme.fontWeights[1]};
      color: ${theme.colors.nature.n5};
    }
  `}
`;

export const FootText = styled.span`
  ${emphasis}
`;

export const FootCount = styled.span`
  white-space: nowrap;
  ${emphasis}
`;
